import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import Locales from 'locales';
import Modal from 'components/shared/Modal';
import { PreferencesContext } from 'context';
import { Button } from 'components/ui/button';
import { Spinner } from 'components/ui/spinner';
import PreferencesForm from './PreferencesForm';

const AddCampaignModal = ({ isOpened = false, closeModal = () => {}, onSubmit, currentYear, campaigns, isLoading }) => {
  const {
    registrationDeposit,
    religiousSupervisorsQuota,
    medicalSupervisorsQuota,
    minPilgrimForAuthorization,
    pilgrimEligibilityMinAge,
    totalPilgrimQuota,
    religiousSupervisorsRatio,
    medicalSupervisorsRatio,
  } = useContext(PreferencesContext);

  const form = useForm({
    mode: 'onChange',
    defaultValues: {
      campaign_year: '',
      campaign_registration_end_date: null,
      pilgrim_eligibility_min_age: pilgrimEligibilityMinAge,
      registration_deposit: registrationDeposit,
      certificate_min_active_pilgrim: minPilgrimForAuthorization,
      religious_supervisors_quota: religiousSupervisorsQuota,
      medical_supervisors_quota: medicalSupervisorsQuota,
      religious_supervisors_ratio: religiousSupervisorsRatio,
      medical_supervisors_ratio: medicalSupervisorsRatio,
      total_pilgrim_quota: totalPilgrimQuota,
    },
  });

  const { isValid } = form.formState;
  const campaignYearValue = form.watch('campaign_year');
  const endDateValue = form.watch('campaign_registration_end_date');

  const isSubmitDisabled = isLoading || !isValid || !campaignYearValue || !endDateValue;

  const handleAddCampaign = () => {
    form.handleSubmit(onSubmit)();
    closeModal();
  };

  return (
    <Modal
      isOpen={isOpened}
      onOpenChange={closeModal}
      title="Créer une nouvelle campagne"
      description="Configurez les paramètres de la nouvelle campagne. Tous les champs sont obligatoires."
      footer={
        <div className="flex justify-end gap-3">
          <Button variant="outline" onClick={closeModal}>
            {Locales.base.button.discard}
          </Button>

          <Button variant="hajj" disabled={isSubmitDisabled} onClick={handleAddCampaign}>
            {isLoading && <Spinner />}
            Créer la campagne
          </Button>
        </div>
      }
    >
      <PreferencesForm
        form={form}
        onSubmit={onSubmit}
        currentYear={currentYear}
        campaigns={campaigns}
        isLoading={isLoading}
        isNewCampaign
      />
    </Modal>
  );
};

AddCampaignModal.propTypes = {
  isOpened: PropTypes.bool,
  closeModal: PropTypes.func,
  onSubmit: PropTypes.func,
  currentYear: PropTypes.number,
  isLoading: PropTypes.bool,
};

export default AddCampaignModal;
